import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <div className="font-mono text-sm font-medium text-primary">404</div>
        <h1 className="lp-h2 mb-3 mt-2">This page could not be found.</h1>
        <p className="lp-body mb-6 text-muted-foreground">The route you requested does not exist.</p>
        <a href="/" className="btn-primary text-[15px]">Return home</a>
      </div>
    </div>
  );
};

export default NotFound;
